/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package coreui.theme

import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

object Shape {
    val none = 0.px
    val extraSmall = 4.px
    val small = 8.px
    val medium = 12.px
    val large = 16.px
    val extraLarge = 20.px
    val round = 50.percent
}